import { connect } from 'react-redux';

import Global from '../../../../store/global-selectors';
import * as PostagePurchaseActions from '../../../../store/postage-purchase/postage-purchase.actions';
import * as BulkPurchaseActions from '../../../../store/bulk/purchase/bulk.purchase.actions';
import * as BulkActions from '../../../../store/bulk/bulk.actions';
import { CostReviewBaseContainer } from '../../../../containers/cost-review-modal/cost-review-base-container';

import { CostReviewBody } from '../cost-review';

const mapStateToProps = (state, props) => {
  const { jobGuid, error } = props;
  const { appliedSavings, costReviewData, isApplyingRecommendations, recommendationSummary } =
    Global.selectBulkJobByJobGuid(state, { jobGuid }) || {};

  const isCostReviewDataEmpty = costReviewData == null || Object.entries(costReviewData).length === 0;
  const shouldShowError = error && isCostReviewDataEmpty;

  const {
    userDateFormat,
    providers,
    walletedProviderGroups,
    insurances,
    balanceMaintained,
    enoughFunds,
    isContinueDisabled,
    userHasBillingInfoSetup,
    costWarnings,
    shipDate,
    shipFromCount,
  } = CostReviewBaseContainer(costReviewData, state);

  const bulkShipDate = Global.selectBulkShipDate(state);
  const { upsTermsRequired } = costReviewData ?? {};

  return {
    shipDate: bulkShipDate || shipDate,
    userDateFormat,
    providers,
    walletedProviderGroups,
    insurances,
    balanceMaintained,
    enoughFunds,
    isContinueDisabled,
    userHasBillingInfoSetup,
    costWarnings,
    shipFromCount,
    isLoading: isCostReviewDataEmpty && !error,
    shouldShowError,
    recommendationSummary,
    totalAppliedSavings: appliedSavings,
    isApplyingRecommendations,
    upsTermsRequired,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  const { jobGuid } = props;
  return {
    purchasePostage: (providers, insurances, wallets, tracking, onAddFundsComplete, closeModal) => {
      dispatch(
        PostagePurchaseActions.postageAndInsurancePurchaseRequest(
          jobGuid,
          providers,
          insurances,
          wallets,
          tracking,
          onAddFundsComplete,
          closeModal,
        ),
      );
    },
    deferPostagePurchase: () => dispatch(PostagePurchaseActions.postagePurchaseDeferred(jobGuid, props.costReviewData)),
    walletPurchaseAmountChanged: (walletId, amount) => dispatch(BulkPurchaseActions.walletPurchaseAmountChanged(jobGuid, walletId, amount)),
    providerPurchaseAmountChanged: (provider, amount) =>
      dispatch(BulkPurchaseActions.providerPurchaseAmountChanged(jobGuid, provider, amount)),
    insurancePurchaseAmountChanged: (provider, amount) =>
      dispatch(BulkPurchaseActions.insurancePurchaseAmountChanged(jobGuid, provider, amount)),
    onShipDateChanged: (shipDate) => dispatch(BulkActions.bulkSetShipDate(shipDate)),
    closeOrderDetailsModal: () => dispatch(PostagePurchaseActions.closeOpenedModalsModals()),
    onRetry: () => dispatch(BulkPurchaseActions.costReviewBulkRetry(jobGuid)),
    applyRecommendations: (bulkUpdateJobGuid, serviceFilters, insuranceFilters, rateShopperFilters, isRateShopperRecommendationsEnabled) =>
      dispatch(
        BulkPurchaseActions.costReviewApplyRecommendations({
          costReviewJobGuid: jobGuid,
          bulkUpdateJobGuid,
          serviceFilters,
          insuranceFilters,
          rateShopperFilters,
          isRateShopperRecommendationsEnabled,
        }),
      ),
  };
};

export const LabelBatchCostReviewContainer = connect(mapStateToProps, mapDispatchToProps)(CostReviewBody);
